import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface MediawikiTabProps {
  integration: Integration | null;
}

function MediawikiTab({ integration }: MediawikiTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="mediawiki_url">URL MediaWiki</FormLabel>
        <FormInput
          id="mediawiki_url"
          name="mediawiki_url"
          defaultValue={integration?.mediawiki_url}
          placeholder="https://wiki.exemplo.com/api.php"
        />
      </FormField>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="mediawiki_username">Usuário</FormLabel>
          <FormInput
            id="mediawiki_username"
            name="mediawiki_username"
            defaultValue={integration?.mediawiki_username}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="mediawiki_password">Senha</FormLabel>
          <FormInput
            type="password"
            id="mediawiki_password"
            name="mediawiki_password"
            defaultValue={integration?.mediawiki_password}
          />
        </FormField>
      </div>
    </div>
  );
}

export default MediawikiTab;
